var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25V20C20 13.0975 23.0975 7.5 30 7.5C36.9025 7.5 40 13.0975 40 20V25M40 35V42.5M8.75 44.5V33C8.75 30.2 8.75 28.8 9.295 27.7325C9.77393 26.7908 10.5389 26.025 11.48 25.545C12.55 25.0025 13.95 25.0025 16.75 25.0025H43.25C46.05 25.0025 47.45 25.0025 48.52 25.545C49.4608 26.0244 50.2256 26.7892 50.705 27.73C51.25 28.8 51.25 30.2 51.25 33V44.5C51.25 47.3 51.25 48.7 50.705 49.77C50.2256 50.7108 49.4608 51.4756 48.52 51.955C47.45 52.5 46.05 52.5 43.25 52.5H16.75C13.95 52.5 12.55 52.5 11.48 51.955C10.5392 51.4756 9.77436 50.7108 9.295 49.77C8.75 48.7025 8.75 47.3025 8.75 44.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.3ff1e6e8912fd8cea15fad8ba37d46d8.svg";
export { ForwardRef as ReactComponent };